import React, { forwardRef } from "react";

/**
 * H3 Component
 * Consolidates standard heading 3 styling across modules.
 * Default styles: text-white text-4xl text-center
 */
export const H3 = forwardRef(function H3(
  { children, title, className = "", ...props },
  ref
) {
  return (
    <h3
      ref={ref}
      className={`font-primary text-white text-subhead leading-subhead font-semibold m-0 mb-[15px] text-center ${className}`.trim()}
      {...props}
    >
      {children ?? title}
    </h3>
  );
});

export default H3;
